import { Params } from "next/dist/shared/lib/router/utils/route-matcher";
import StpApi from "../utils/stp-api";

const stpApi = new StpApi();

// Auth

export const login = (credentials: any) => {
  return stpApi.postUnsigned(`/auth/login`, credentials, {withCredentials: true});
};

export const createUserMailchimp = (email: string) => {
  return stpApi.postUnsigned(`/auth/mailchimp`, { email }, {});
};

export const confirmEmail = (token: any) => {
  return stpApi.postUnsigned(`/auth/confirm-email`, { token }, {});
};

export const getRefreshToken = () => {
  return stpApi.getRefreshToken();
};

export const logout = () => {
  return stpApi.postUnsigned(`/auth/logout`, {}, {withCredentials: true});
};

export const resetPassword = (email: string) => {
  return stpApi.postUnsigned(`/auth/resetPassword`, { email }, {});
};

export const newPassword = (auth: any) => {
  return stpApi.postUnsigned(`/auth/newPassword`, auth, {});
};

// Users

export const getAllUsers = () => {
  return stpApi.get(`/users/all-users`, {});
};

export const getAdminAndEntrepreneurUsers = () => {
  return stpApi.get(`/users/all-admin-entrepreneur-users`, {});
};

export const getExcelUsers = (page: number, pageSize: number) => {
  return stpApi.get(`/users/excel-users/${page}/${pageSize}`, {});
};

export const getExcelUsersCNMV = (page: number, pageSize: number) => {
  return stpApi.get(`/users/excel-users-cnmv/${page}/${pageSize}`, {});
};

export const getExcelUsersCNMV2024 = (page: number, pageSize: number) => {
  return stpApi.get(`/users/excel-users-cnmv-2024/${page}/${pageSize}`, {});
};

export const getUserTypeById = (id: string | number) => {
  return stpApi.get(`/users/user-type/${id}`, {});
};

export const getUserIncompleInfo = (id: string | number) => {
  return stpApi.get(`/users/user-incomplete-info/${id}`, {});
};

export const getEnterpriseById = (id: string | number) => {
  return stpApi.get(`/users/enterprise/${id}`, {});
};

export const findAllEnterprise = () => {
  return stpApi.get(`/users/companies`, {});
};

export const getMangopayWalletById = (id: string | number) => {
  return stpApi.get(`/users/mangopay-wallet/${id}`, {});
};

export const createUserFromAdmin = (user: any) => {
  return stpApi.post(`/users/new-user`, user, {});
};

export const createUserFromWeb = (user: any) => {
  return stpApi.post(`/users/register`, user, {});
};

export const createEnterprise = (userId: number | string, enterprise: any) => {
  return stpApi.post(`/users/enterprise/${userId}`, enterprise, {});
};

export const createEntrepreneur = (enterprise: any) => {
  return stpApi.post(`/users/entrepreneur-register/`, enterprise, {});
};

export const getUserById = (id: string | number) => {
  return stpApi.get(`/users/user/${id}`, {});
};

export const updateUserById = (id: string | number, user: any) => {
  return stpApi.put(`/users/user/${id}`, user, {});
};

export const updateMangopayUserDataById = (id: string | number, user: any) => {
  return stpApi.put(`/users/user-mangopay/${id}`, user, {});
};

export const updateEmailUserDataById = (id: string | number, user: any) => {
  return stpApi.put(`/users/user-email/${id}`, user, {});
};

export const updateTypeUserDataById = (id: string | number, user: any) => {
  return stpApi.put(`/users/user-type/${id}`, user, {});
};

export const updateActiveUserById = (id: string | number, user: any) => {
  return stpApi.put(`/users/user-active/${id}`, user, {});
};

export const updateUserEnterpriseById = (
  id: string | number,
  userEnterprise: any
) => {
  return stpApi.put(`/users/user-enterprise/${id}`, userEnterprise, {});
};

export const updateEquityQuizzUserDataById = (
  userId: string | number,
  data: any
) => {
  return stpApi.put(`/users/user-equity-quizz/${userId}`, data, {});
};

export const updateLendingQuizzUserDataById = (
  userId: string | number,
  data: any
) => {
  return stpApi.put(`/users/user-lending-quizz/${userId}`, data, {});
};

export const updateCalculatorIncomeUserDataById = (
  userId: string | number,
  data: any
) => {
  return stpApi.put(`/users/user-calculator-income/${userId}`, data, {});
};

export const updateIsExperiencedUserDataById = (
  userId: string | number,
  data: any
) => {
  return stpApi.put(`/users/user-is-experienced/${userId}`, data, {});
};

// Mangopay

export const getWallet = (id: any) => {
  return stpApi.get(`/mangopay/wallet/wallet/${id}`, {});
};

export const getCurrentUserSCA = (userMangopayId: any) => {
  return stpApi.get(`/mangopay/user/get-SCA/${userMangopayId}`, {});
};

export const enrollCurrentUserSCA = (userMangopayId: any) => {
  return stpApi.post(`/mangopay/user/enroll-SCA`, { userMangopayId }, {});
};

export const updateCurrentUserSCA = (userId: any, body: any) => {
  return stpApi.put(`/mangopay/user/${userId}`, body, {});
};

export const createUserWallet = (wallet: any) => {
  return stpApi.post(`/mangopay/wallet`, wallet, {});
};

export const createMangopayUser = (user: any, appUserId: any) => {
  return stpApi.post(`/mangopay/user/natural`, {user, appUserId}, {});
};

export const createMangopayBankAccount = (bankAccount: any) => {
  return stpApi.post(`/mangopay/user/bank`, bankAccount, {});
};

export const getKYCByUserId = (id: string | number) => {
  return stpApi.get(`/mangopay/user/kyc/${id}`, {});
};

export const createKYC = (kyc: any) => {
  return stpApi.post(`/mangopay/user/kyc`, kyc, {});
};

export const createKYCPage = (kycPage: any) => {
  return stpApi.post(`/mangopay/user/kycpage`, kycPage, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const createMangopayMandate = (mandateInfo: any) => {
  return stpApi.post(`/mangopay/user/mandate`, mandateInfo, {});
};

export const createTransfer = (transfer: any) => {
  return stpApi.post(`/mangopay/transfer`, transfer, {});
};

export const createPayin = (payin: any) => {
  return stpApi.post(`/mangopay/payment/payin`, payin, {});
};

export const createPayout = (payout: any) => {
  return stpApi.post(`/mangopay/payment/payout`, payout, {});
};

export const getTransactionsByWallet = (walletId: any) => {
  return stpApi.get(`/mangopay/wallet/transactions/${walletId}`, {});
};

export const getPayin = (payinId: any) => {
  return stpApi.get(`/mangopay/payment/payin/${payinId}`, {});
};

export const getPayout = (payoutId: any) => {
  return stpApi.get(`/mangopay/payment/payout/${payoutId}`, {});
};

export const getTransfer = (transferId: any) => {
  return stpApi.get(`/mangopay/transfer/${transferId}`, {});
};

export const getMangopayUser = (userId: any) => {
  return stpApi.get(`/mangopay/user/${userId}`, {});
};

export const getBankAccounts = (userId: any) => {
  return stpApi.get(`/mangopay/user/bank/accounts/${userId}`, {});
};

export const getBankAccountByUser = (userId: any, bankAccountId: any) => {
  return stpApi.get(`/mangopay/user/bank/${userId}/${bankAccountId}`, {});
};

export const getBankAccountAliasByWallet = (walletId: any) => {
  return stpApi.get(`/mangopay/user/bankAlias/wallet/${walletId}`, {});
};

export const getBankAccountAlias = (bankAliasId: any) => {
  return stpApi.get(`/mangopay/user/bankAlias/${bankAliasId}`, {});
};

export const createBankAccountAlias = (bankAlias: any) => {
  return stpApi.post(`/mangopay/user/bankAlias`, bankAlias, {});
};

export const updateBankAccountAliasIdByUserId = (userId: any, bankAccountAliasId: any) => {
  return stpApi.put(`/users/bankAccountAliasId/${userId}`, { bankAccountAliasId }, {});
};

export const uploadBankStatement = (id: any, bankStatement: FormData) => {
  return stpApi.post(`/mangopay/user/upload-bank-statement/${id}`, bankStatement, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteBankStatement = (id: any) => {
  if (!id) {
    throw new Error("ID is required to delete the bank statement");
  }
  return stpApi.delete(`/mangopay/user/delete-bank-statement/${id}`, {});
};

export const deleteMangopayUser = (userMangopayId: any, userId: any) => {
    return stpApi.delete(`/mangopay/user/delete-mangopay-user/${userMangopayId}/${userId}`, {});
};


// Comments

export const getAllComments = () => {
  return stpApi.get(`/comments`, {});
};

export const getCommentsByProject = (id: string | number) => {
  return stpApi.get(`/comments/project/${id}`, {});
};

export const getComment = (id: string | number) => {
  return stpApi.get(`/comments/${id}`, {});
};

export const createComment = (comment: any) => {
  return stpApi.post(`/comments`, comment, {});
};

export const updateComment = (id: string | number, comment: any) => {
  return stpApi.put(`/comments/${id}`, comment, {});
};

export const deleteComment = (id: string | number) => {
  return stpApi.delete(`/comments/${id}`, {});
};

// Partners

export const getPartner = (id: string | number) => {
  return stpApi.get(`/partners/${id}`, {});
};

export const createPartner = (partner: any) => {
  return stpApi.post(`/partners/new`, partner, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updatePartner = (id: string | number, partner: any) => {
  return stpApi.put(`/partners/${id}`, partner, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getAllPartners = () => {
  return stpApi.get(`/partners/all`, {});
};

export const getAllUsersByPartner = (partnerId: string | number, partnerCode: string) => {
  return stpApi.get(`/partners/all-partner-users/${partnerId}/${partnerCode}`, {});
};

export const getAllPartnersByUser = (id: string | number) => {
  return stpApi.get(`/partners/all-user/${id}`, {});
};

export const getAllPartnersByProject = (projectId: string | number) => {
  return stpApi.get(`/partners/all-project/${projectId}`, {});
};

export const createUserPartner = (id: string | number, partner: any) => {
  return stpApi.post(`/partners/add-partner/${id}`, partner, {});
};

export const createProjectPartner = (
  projectId: string | number,
  partner: any
) => {
  return stpApi.post(`/partners/add-project-partner/${projectId}`, partner, {});
};

export const deleteUserPartner = (
  id: string | number,
  partnerId: string | number
) => {
  return stpApi.delete(`/partners/delete-partner/${id}/${partnerId}`, {});
};

export const deleteProjectPartner = (
  projectId: string | number,
  partnerId: string | number
) => {
  return stpApi.delete(
    `/partners/delete-project-partner/${projectId}/${partnerId}`,
    {}
  );
};

// Projects option user

export const getAllFollowersUsersByProject = (projectId: string | number, limit: number = 10000) => {
  return stpApi.get(
    `/projects-option-user/all-followers-users-project/${projectId}/${limit}`,
    {}
  );
};

export const getAllProjectsName = () => {
  return stpApi.get(`/projects-option-user/projects`, {});
};

export const getAllProjectsAndInvestors = () => {
  return stpApi.get(
    `/projects-option-user/all-projects-featured-investors`,
    {}
  );
};

export const getAllFeaturedUsersByProject = (projectId: string | number) => {
  return stpApi.get(
    `/projects-option-user/all-featured-investors-project/${projectId}`,
    {}
  );
};

export const getAllFeaturedInvestorProjectsByUser = (id: string | number) => {
  return stpApi.get(
    `/projects-option-user/all-project-featured-investor/${id}`,
    {}
  );
};

export const getAllUsersWithPaidAndCompletedTransactionsByProject = (id: string | number) => {
  return stpApi.get(
    `/transactions/all-investors-transactions-paid/${id}`,
    {}
  );
};

export const getFirstTimeUserProject = (
  projectId: string | number,
  userId: string | number
) => {
  return stpApi.get(
    `/projects-option-user/first-time-user-project/${projectId}/${userId}`,
    {}
  );
};

export const getUserRange = (userId: string | number) => {
  return stpApi.get(`/projects-option-user/user-range/${userId}`, {});
};

export const createFirstTimeUserProject = (
  projectId: string | number,
  userId: string | number,
  body: any
) => {
  return stpApi.post(
    `/projects-option-user/first-time-user-project/${projectId}/${userId}`,
    body,
    {}
  );
};

export const createProjectFeaturedInvestor = (
  id: string | number,
  featuredInvestor: any
) => {
  return stpApi.post(
    `/projects-option-user/add-featured-investor/${id}`,
    featuredInvestor,
    {}
  );
};

export const deleteProjectFeaturedInvestor = (
  id: string | number,
  projectId: string | number
) => {
  return stpApi.put(
    `/projects-option-user/delete-featured-investor/${id}/${projectId}`,
    {},
    {}
  );
};

export const followProject = (
  body: any
) => {
  return stpApi.post(
    `/projects-option-user/follow-project/`,
    body,
    {}
  );
};

// Orizon

export const getOrizonUsers = () => {
  return stpApi.get(`/users/orizon-users`, {});
};

export const getSubscriptionByUserId = (id: string | number) => {
  return stpApi.get(`/users/user/subscription-data/${id}`, {});
};

// export const login = (email, password) => {
//     return stpApi.postUnsigned(`/auth/login`, { email, password })
// }

// export const register = (name, surname, email, password, orizonMemberType) => {
//     return stpApi.postUnsigned(`/auth/register`, { name, surname, email, password, orizonMemberType });
// }

// export const resetPassword = (email) => {
//     return stpApi.postUnsigned(`/auth/resetPassword`, { email });
// }

// export const setPassword = (password, passwordConfirm, token) => {
//     return stpApi.postUnsigned(`/auth/newPassword`, { password, passwordConfirm, token });
// }

// export const refreshToken = () => {
//     return stpApi.post(`/auth/refreshToken`);
// }

// export const updateUser = (id, user) => {
//     return stpApi.put(`/users/user/${id}`, user);
// }

// export const updateGroupUser = (id, user) => {
//     return stpApi.put(`/users/group-user/${id}`, user);
// }

// export const findOneGroupUserById = (id) => {
//     return stpApi.get(`/users/group-user/${id}`);
// }

// export const updateExperiencedUser = (id, data) => {
//     return stpApi.put(`/users/user/experienced/${id}`, data);
// }

// export const updateGroupExperiencedUser = (id, data) => {
//     return stpApi.put(`/users/group-user/experienced/${id}`, data);
// }

// export const getToken = () => {
//     return stpApi.get(`/users/token`);
// }

// Projects

export const getAllProjects = () => {
  return stpApi.get(`/projects/all`, {});
};

export const getAllProjectsForExcel = () => {
  return stpApi.get(`/projects/all-for-excel`, {});
};

export const getAllCompletedNonCompletedProjectsForExcel = () => {
  return stpApi.get(`/projects/all-completed-non-completed-for-excel`, {});
};

export const getAllProjectsByStatus = (status: string) => {
  return stpApi.get(`/projects/all/${status}`, {});
};

export const getAllProjectsByType = (type: string) => {
  return stpApi.get(`/projects/all-type/${type}`, {});
};

export const getProjectsByEntrepreneurUserId = (
  entrepreneurUserId: string | number
) => {
  return stpApi.get(`/projects/user-entrepreneur/${entrepreneurUserId}`, {});
};

export const getAllCurrentsProjectsByType = (
  type: string,
  skip: number,
  limit: number
) => {
  return stpApi.get(`/projects/current-all-type/${type}/${skip}/${limit}`, {});
};

export const getPortfolioProjects = (skip: number, limit: number) => {
  return stpApi.get(`/projects/portfolio/${skip}/${limit}`, {});
};

export const getProjectCardInfo = (id: string | number) => {
  return stpApi.get(`/projects/card-info/${id}`, {});
};

export const getIntroProjectById = (id: string | number) => {
  return stpApi.get(`/projects/intro/${id}`, {});
};

export const getStep1ProjectById = (id: string | number) => {
  return stpApi.get(`/projects/step1/${id}`, {});
};

export const getStep2ProjectById = (id: string | number) => {
  return stpApi.get(`/projects/step2/${id}`, {});
};

export const getStep3ProjectById = (id: string | number) => {
  return stpApi.get(`/projects/step3/${id}`, {});
};

export const getStep4ProjectById = (id: string | number) => {
  return stpApi.get(`/projects/step4/${id}`, {});
};

export const getStep5ProjectById = (id: string | number) => {
  return stpApi.get(`/projects/step5/${id}`, {});
};

export const getLendingProjectById = (id: string | number) => {
  return stpApi.get(`/projects/lending/${id}`, {});
};

export const getLendingProjecsForExcel = () => {
  return stpApi.get(`/projects/lending-for-excel`, {});
};

export const getProjectById = (id: string | number) => {
  return stpApi.get(`/projects/project-investment/${id}`, {});
};

export const getExtraInfoProjectById = (id: string | number) => {
  return stpApi.get(`/projects/project-investment/extra-info/${id}`, {});
};

export const getProjectBasicInfoById = (id: string | number) => {
  return stpApi.get(`/projects/project-basic-info/${id}`, {});
};

export const getProjectContractsById = (id: string | number) => {
  return stpApi.get(`/projects/contracts/${id}`, {});
};

export const createProject = (project: any) => {
  return stpApi.post(`/projects/intro`, project, {});
};

export const updateStatusProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/status/${id}`, project, {});
};

export const updateLendingStateProject = (
  id: string | number,
  project: any
) => {
  return stpApi.put(`/projects/lending-state/${id}`, project, {});
};

export const updateIntroProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/intro/${id}`, project, {});
};

export const updateStep1ProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/step1/${id}`, project, {});
};

export const updateStep2ProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/step2/${id}`, project, {});
};

export const updateStep3ProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/step3/${id}`, project, {});
};

export const updateStep4ProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/step4/${id}`, project, {});
};

export const updateMangopayMandate = (id: string | number, mandate: any) => {
  return stpApi.put(`/projects/mangopay-mandate/${id}`, mandate, {});
};

export const updateStep5ProjectById = (id: string | number, project: any) => {
  return stpApi.put(`/projects/step5/${id}`, project, {});
};

export const updateRefundPayingProject = (
  id: string | number,
  refundPaying: any
) => {
  return stpApi.put(`/projects/refund-paying/${id}`, refundPaying, {});
};

export const getProjectCount = () => {
  return stpApi.get(`/projects/project-count/`, {});
};




// multimedia files

export const uploadProjectMultimedia = (
  type: string,
  id: string | number,
  image: any
) => {
  return stpApi.post(`/files/multimedia/${type}/${id}`, image, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// documents

export const getDocumentsByProject = (id: string | number) => {
  return stpApi.get(`/documents/${id}`, {});
};

export const uploadDoc = (
  id: string | number,
  type: string,
  title: string,
  doc: any
) => {
  return stpApi.post(`/documents/${id}/${type}/${title}`, doc, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteDocumentById = (id: string | number) => {
  return stpApi.delete(`/documents/${id}`, {});
};

export const getEntrepreneurDocumentsByUserId = (
  entrepreneurUserId: string | number
) => {
  return stpApi.get(`/entrepreneur-documents/${entrepreneurUserId}`, {});
};

export const uploadEntrepreneurDocs = (
  entrepreneurUserId: string | number,
  title: string,
  doc: any
) => {
  return stpApi.post(
    `/entrepreneur-documents/${entrepreneurUserId}/${title}`,
    doc,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteEntrepreneurDocumentById = (id: string | number) => {
  return stpApi.delete(`/entrepreneur-documents/${id}`, {});
};

// contracts

export const getContractByProject = (projectId: string | number) => {
  return stpApi.get(`/contracts/contratc/${projectId}`, {});
};

// team users

export const getTeamUsersByProject = (id: string | number) => {
  return stpApi.get(`/team-users/${id}`, {});
};

export const createTeamUser = (id: string | number, image: any) => {
  return stpApi.post(`/team-users/create/${id}`, image, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadTeamUserAvatar = (id: string | number, image: any) => {
  return stpApi.post(`/team-users/${id}`, image, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateTeamUser = (
  id: string | number,
  projectId: string | number,
  teamUser: any
) => {
  return stpApi.put(`/team-users/${id}/${projectId}`, teamUser, {});
};

export const deleteTeamUserById = (id: string | number) => {
  return stpApi.delete(`/team-users/${id}`, {});
};

// export const getEquityProjects = () => {
//     return stpApi.get(`/projects`);
// }

// export const getAllEquityProjects = () => {
//     return stpApi.get(`/projects/all`, {});
// }

// export const findOneProject = (id) => {
//     return stpApi.get(`/projects/project/${id}`);
// }

// export const findProjectTeamUsers = (id) => {
//     return stpApi.get(`/projects/project-team-users/${id}`);
// }

// export const findProjectDocs = (id) => {
//     return stpApi.get(`/projects/project-docs/${id}`);
// }

// Transactions

export const getAllTransactions = () => {
  return stpApi.get(`/transactions/all`, {});
};

export const getAllTransactionsByProjectId = (id: string | number) => {
  return stpApi.get(`/transactions/all-project/${id}`, {});
};

export const getAllTransactionsByUserId = (id: string | number) => {
  return stpApi.get(`/transactions/all-user/${id}`, {});
};

export const getPendingTransactionsByUserId = (id: string | number) => {
  return stpApi.get(`/transactions/pending/${id}`, {});
};

export const getPendingMangopayFundsTransactionsByUserId = (
  id: string | number
) => {
  return stpApi.get(`/transactions/pending-mangopay/${id}`, {});
};

export const getLastCompletedInvestmentsByUserId = (
  id: string | number
) => {
  return stpApi.get(`/transactions/last-completed-investments/${id}`, {});
};

export const getAllRefundsByProjectId = (projectId: string | number) => {
  return stpApi.get(`/transactions/all-company-refunds/${projectId}`, {});
};

export const getAllInvestorsRefundsByProjectId = (
  projectId: string | number
) => {
  return stpApi.get(`/transactions/all-investors-refunds/${projectId}`, {});
};

export const getAllInvestorsRefunds = (page: number, pageSize: number) => {
  return stpApi.get(`/transactions/all-investors-refunds-all-projects/${page}/${pageSize}`, {});
};

export const getAllInvestorsRefundsByYear = (page: number, pageSize: number) => {
  return stpApi.get(`/transactions/all-investors-refunds-all-projects-by-year/${page}/${pageSize}`, {});
};

export const getVariableRefunds = (projectId: string | number) => {
  return stpApi.get(`/transactions/make-variable-refunds/${projectId}`, {});
};

export const showVariableRefundsBudget = (projectId: string | number) => {
  return stpApi.get(`/transactions/show-variable-refunds-bufget/${projectId}`, {});
};

export const getTransactionsById = (id: string | number) => {
  return stpApi.get(`/transactions/investment/${id}`, {});
};

export const getProjectTypeTransactionById = (id: string | number) => {
  return stpApi.get(`/transactions/invest/step2/${id}`, {});
};

export const getDataProjectForInvestTransactionById = (id: string | number) => {
  return stpApi.get(`/transactions/invest/step3/${id}`, {});
};

export const getDataTransactionForReminderEmailById = (id: string | number) => {
  return stpApi.get(`/transactions/transaction-to-reminder-email/${id}`, {});
};

export const getDataProjectForFinalInvestTransactionById = (
  id: string | number
) => {
  return stpApi.get(`/transactions/invest/step4/${id}`, {});
};

export const getDataProjectForPaidInvestTransactionById = (
  id: string | number
) => {
  return stpApi.get(`/transactions/invest/step5/${id}`, {});
};

export const getCurrentAmountInvestmentByProject = (
  projectId: string | number
) => {
  return stpApi.get(`/transactions/current-investments/${projectId}`, {});
};

export const getCurrentRealAmountInvestmentByProject = (
  projectId: string | number
) => {
  return stpApi.get(`/transactions/real-current-investments/${projectId}`, {});
};

export const getCapitalAndInterestAggregatedByTransactionId = (
  transactionId: string | number
) => {
  return stpApi.get(`/transactions/refunds-aggregation/${transactionId}`, {});
};

export const getRefundsByUserId = (userId: string | number) => {
  return stpApi.get(`/transactions/refunds/${userId}`, {});
};

export const updateStatusTransaction = (
  id: string | number,
  transaction: any
) => {
  return stpApi.put(`/transactions/status/${id}`, transaction, {});
};

export const createTransactionStep1 = (
  userId: string | number,
  transaction: any
) => {
  return stpApi.post(`/transactions/invest/step1/${userId}`, transaction, {});
};

export const updateTransactionStep2 = (transactionId: string | number) => {
  return stpApi.put(`/transactions/invest/step2/${transactionId}`, {}, {});
};

export const updateTransactionStep3 = (
  transactionId: string | number,
  transaction: any
) => {
  return stpApi.put(
    `/transactions/invest/step3/${transactionId}`,
    transaction,
    {}
  );
};

export const updateTransactionStep4 = (
  transactionId: string | number,
) => {
  return stpApi.put(
    `/transactions/invest/step4/${transactionId}`, {}, {}
  );
};

export const updateTransactionStep5 = (transactionId: string | number) => {
  return stpApi.put(`/transactions/invest/step5/${transactionId}`, {}, {});
};

export const updateTransactionStep5ForMangopayPending = (
  transactionId: string | number
) => {
  return stpApi.put(
    `/transactions/invest/step5-mangopay-pending/${transactionId}`,
    {},
    {}
  );
};

// export const getTransactionsByUserId = (userId) => {
//     return stpApi.get(`/transactions/${userId}`);
// }

// export const getTransactionsByProjectAndUser = (projectId, userId) => {
//     return stpApi.get(`/transactions/project/${projectId}/${userId}`);
// }

// export const getTotalInvestedByProject = (projectId) => {
//     return stpApi.get(`/transactions/total-invested/${projectId}`);
// }

// export const postTransaction = (projectId, userId) => {
//     return stpApi.post(`/transactions/`, { project: projectId, user: userId});
// }

// Geo

export const getCountries = () => {
  return stpApi.get(`/geo/countries`, {});
};

export const getCities = () => {
  return stpApi.get(`/geo/cities`, {});
};

// export const getProvinces = () => {
//     return stpApi.get(`/geo/provinces`);
// }

// ODS icons

export const getAllOdsIcons = () => {
  return stpApi.get(`/ods-icons/all`, {});
};

export const getOdsIconsByProject = (id: string | number) => {
  return stpApi.get(`/ods-icons/${id}`, {});
};

export const addOdsIconsByProjectId = (id: string | number, icon: number) => {
  return stpApi.post(`/ods-icons/${id}`, { icon }, {});
};

export const deleteOdsIconsById = (
  id: string | number,
  projectId: string | number
) => {
  return stpApi.delete(`/ods-icons/${id}/${projectId}`, {});
};

// Utils

export const getCategories = () => {
  return stpApi.get(`/utils/categories`, {});
};

export const getCategoryById = (id: string, language: string) => {
  return stpApi.get(`/utils/category/${id}/${language}`, {});
};

export const generateAndDownloadPdf = async (
  htmlContent: string,
  fileName: string
) => {
  const response = await stpApi.postUnsigned(
    `/utils/generate-pdf`,
    { fileName, htmlContent },
    { responseType: "blob" }
  );

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);

  // Abrir una nueva pestaña con la URL del objeto blob
  window.open(url, '_blank');
  window.URL.revokeObjectURL(url);

  // Descargar pdf
  // const url = window.URL.createObjectURL(new Blob([response.data]));
  // const link = document.createElement("a");
  // link.href = url;
  // link.setAttribute("download", `${fileName}.pdf`);
  // document.body.appendChild(link);
  // link.click();
  // window.URL.revokeObjectURL(url);
  // link.remove();
};
export const generatePdfAttachment = async (
  htmlContent: string,
  fileName: string
) => {
  const response = await stpApi.postUnsigned(
    `/utils/generate-pdf`,
    { fileName, htmlContent },
    { responseType: "blob" }
  );

  const blob = new Blob([response.data], { type: 'application/pdf' });
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = function () {
      const base64data: any = reader.result;

      const pdfFileName = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;

      const attachment = {
        type: "application/pdf",
        name: pdfFileName,
        content: base64data.split("base64,")[1]
      };

      resolve(attachment);
    };

    reader.onerror = reject;

    reader.readAsDataURL(blob);
  })
}

export const getAllLabels = () => {
  return stpApi.getUnsigned(`/labels`, {});
};

export const getLabelsByIds = (
  enId: string | number,
  esId: string | number
) => {
  return stpApi.getUnsigned(`/labels/texts/${enId}/${esId}`, {});
};

export const getLabels = (labels: string[]) => {
  return stpApi.putUnsigned(`/labels`, { labels }, {});
};

export const createLabel = (label: any) => {
  return stpApi.post(`/labels/label`, label, {});
};

export const updateLabel = (label: any) => {
  return stpApi.put(`/labels/label`, label, {});
};

// Log

export const getLastLoginByUser = (userId: string | number) => {
  return stpApi.get(`/log/login/${userId}`, {});
};

// Home admin

export const getFacts = (date: string) => {
  return stpApi.get(`/home-admin/${date}`, {});
};

// blog
export const getBlogPosts = () => {
  return stpApi.get(`/post`, {});
};

//MailChimp
export const sendMailchimp = (params: any) => {
  return stpApi.postUnsigned(`/mail`, params, {});
};
export const searchMailchimp = (params: any) => {
  return stpApi.postUnsigned(`/mail/search`, params, {});
};
export const getMailContent = (emailId: any) => {
  return stpApi.getUnsigned(`/mail/${emailId}`, {});
}
//mail status
export const getMailStatus = () => {
  return stpApi.get(`/mail`, {});
};

export const changeMailStatus = (status: any) => {
  return stpApi.post(`/mail/changeMailStatus`, status, {});
};

//ORIZON
export const updateExperiencedUser = (id: number, data: any) => {
  return stpApi.put(`/users/user/experienced/${id}`, data, {});
};

export const findOneUserById = (id: number) => {
  return stpApi.get(`/users/user/${id}`, {});
};

export const createCheckoutSession = (priceId: string) => {
  return stpApi.post(`/users/createCheckoutSession`, { priceId }, {});
};

//FAQs
export const createFaq = (faq: any) => {
  return stpApi.post(`/faqs`, faq, {})
}

export const getAllFaqs = () => {
  return stpApi.getUnsigned(`/faqs`, {});
};

export const getFaqById = (id: any) => {
  return stpApi.getUnsigned(`/faqs/${id}`, {})
}

export const deleteFaq = (id: any) => {
  return stpApi.delete(`/faqs/${id}`, {})
}

export const updateFaqPosition = (id: number | string, position: any) => {
  return stpApi.put(`/faqs/position/${id}/${position}`, {}, {});
};

export const updateFaq = (id: any) => {
  return stpApi.put(`/faqs`, id, {})
}

// new FAQS

export const createFaqGroup = (faq: any) => {
  return stpApi.post(`/faq-groups`, faq, {})
}

export const getFaqGroups = () => {
  return stpApi.getUnsigned(`/faq-groups`, {});
};

export const getFaqGroupById = (id: any) => {
  return stpApi.getUnsigned(`/faq-groups/${id}`, {})
}

export const updateFaqGroupPosition = (id: number | string, position: any) => {
  return stpApi.put(`/faq-groups/position/${id}/${position}`, {}, {});
};

export const updateFaqGroup = (id: any, faqGroup: any) => {
  return stpApi.put(`/faq-groups/${id}`, faqGroup, {})
}

export const deleteFaqGroupById = (id: any) => {
  return stpApi.delete(`/faq-groups/${id}`, {})
}

export const createNewFaq = (faq: any) => {
  return stpApi.post(`/new-faqs`, faq, {})
}

export const getNewFaqsByGroup = (groupId: any) => {
  return stpApi.getUnsigned(`/new-faqs/group/${groupId}`, {});
};

export const getNewFaqById = (id: any) => {
  return stpApi.getUnsigned(`/new-faqs/${id}`, {})
}

export const updateNewFaqPosition = (id: number | string, position: any) => {
  return stpApi.put(`/new-faqs/position/${id}/${position}`, {}, {});
};

export const updateNewFaq = (id: any, newFaq: any) => {
  return stpApi.put(`/new-faqs/${id}`, newFaq, {})
}

export const deleteNewFaqById = (id: any) => {
  return stpApi.delete(`/new-faqs/${id}`, {})
}


// STATS

export const getTotalUsersRegisteredTimerange = (date: any) => {
  return stpApi.postUnsigned(`/stats/users-registered-timerange`, date, {})
}

export const getTotalCompletedProjects = () => {
  return stpApi.getUnsigned(`/stats/completed-projects`, {});
};

export const getTotalInvested = () => {
  return stpApi.getUnsigned(`/stats/invested`, {});
};

export const getTotalUsersRegistered = (months?: number) => {
  let url = '/stats/users-registered';
  if (months !== undefined) {
    url += `?months=${months}`;
  }
  return stpApi.getUnsigned(url, {});
};

export const getLastUsersRegistered = (months: number) => {
  return stpApi.getUnsigned(`/stats/last-users-registered/${months}`, {});
};

export const getLastMonthsUsersRegistered = () => {
  return stpApi.getUnsigned(`/stats/month-users-registered`, {});
};

export const getYearsUsersRegistered = () => {
  return stpApi.getUnsigned(`/stats/years-users-registered`, {});
};

export const getYearsInvestors = () => {
  return stpApi.getUnsigned(`/stats/years-investors`, {});
};

export const getMonthsInvestors = () => {
  return stpApi.getUnsigned(`/stats/months-investors`, {});
};

export const getDaysInvestors = () => {
  return stpApi.getUnsigned(`/stats/days-investors`, {});
};

export const getLastProjectTransactions = (months: number) => {
  return stpApi.getUnsigned(`/stats/last-project-transactions/${months}`, {});
};

export const getAllProjectTransactionsForStats = () => {
  return stpApi.getUnsigned(`/stats/all-project-transactions`, {});
};

export const getAllProjectTransactionsWithProjectType = (date: any) => {
  return stpApi.postUnsigned(`/stats/all-project-transactions-type`, date, {});
};

export const getTimeframeProjectTransactions = (date: any) => {
  return stpApi.postUnsigned(`/stats/timeframe-project-transactions`, date, {})
}

export const getAllGenderTransactions = (date?: any) => {
  return stpApi.postUnsigned(`/stats/all-gender-transactions`, date,{});
};

export const getAllAgeTransactions = (date?: any) => {
  return stpApi.postUnsigned(`/stats/all-age-transactions`, date,{});
};

export const getAllAgeInvestors = (date?: any) => {
  return stpApi.postUnsigned(`/stats/all-age-investors`, date,{});
};

export const getCompletedProjectTransactions = (date?: any) => {
  return stpApi.postUnsigned(`/stats/completed-project-transactions`, date,{});
};

export const getTimeframeInvestors = (date: any) => {
  return stpApi.postUnsigned(`/stats/timeframe-investors`, date, {})
}

export const getTimeframeUsersRegistered = (date: any) => {
  return stpApi.postUnsigned(`/stats/timeframe-users-registered`, date, {})
}

export const getAllGenderInvestors = (date?: any) => {
  return stpApi.postUnsigned(`/stats/all-gender-investors/`, date, {});
};

export const getSeedProjects = (date?: any) => {
  return stpApi.postUnsigned(`/stats/seeded-projects/`, date, {});
};

/* EQUITY / NOTA CONVERTIBLE */

export const getOnCourseEquityProjects = (date?: any) => {
  return stpApi.postUnsigned(`/stats/on-course-equity-projects/`, date, {});
};

export const getExitEquityProjects = (date?: any) => {
  return stpApi.postUnsigned(`/stats/exit-equity-projects/`, date, {});
};

export const getClosedEquityProjects = (date?: any) => {
  return stpApi.postUnsigned(`/stats/closed-equity-projects/`, date, {});
};

export const getEquityProjectsInvestmentAverage = (date?: any) => {
  return stpApi.postUnsigned(`/stats/average-equity-projects/`, date, {});
};

export const getEquityProjectsExitGoalSum = (date?: any) => {
  return stpApi.postUnsigned(`/stats/goal-sum-exit-equity-projects`, date, {});
};

export const getEquityProjectCloseGoalSum = (date?: any) => {
  return stpApi.postUnsigned(`/stats/goal-sum-close-equity-projects/`, date, {});
};

export const getEquityProjectsOnCourseGoalSum = (date?: any) => {
  return stpApi.postUnsigned(`/stats/goal-sum-on-course-equity-projects/`, date, {});
};

/* LENDING */

export const getLendingProjectsOngoingLoanCount = (date?: any) => {
  return stpApi.postUnsigned(`/stats/ongoing-loan-lending-projects/`, date, {});
};

export const getLendingProjectsFinishedLoanCount = (date?: any) => {
  return stpApi.postUnsigned(`/stats/finished-loan-lending-projects/`, date, {});
};

export const getLendingProjectsUnpaidLoanCount = (date?: any) => {
  return stpApi.postUnsigned(`/stats/unpaid-loan-lending-projects/`, date, {});
};

export const getLendingProjectsDelayedLoanCount = (date?: any) => {
  return stpApi.postUnsigned(`/stats/delayed-loan-lending-projects/`, date, {});
};

export const getLendingProjectsFinishedLoanTotal = (date?: any) => {
  return stpApi.postUnsigned(`/stats/finished-lending-loan-total/`, date, {});
};

export const getLendingProjectsUnpaidLoanTotal = (date?: any) => {
  return stpApi.postUnsigned(`/stats/unpaid-lending-loan-total/`, date, {});
};

export const getLendingProjectsUnfinalizedLoanTotal = (date?: any) => {
  return stpApi.postUnsigned(`/stats/unfinalized-lending-loan-total/`, date, {});
};

export const getLendingProjectsAveragePerceivedProfitability = (date?: any) => {
  return stpApi.postUnsigned(`/stats/percieved-lending-profitability/`, date, {});
};

export const getLendingRepaidCapital = (date?: any) => {
  return stpApi.postUnsigned(`/stats/lending-repaid-capital/`, date, {});
};

export const getLendingRemainingCapital = (date?: any) => {
  return stpApi.postUnsigned(`/stats/lending-remaining-capital/`, date, {});
};

export const getLendingRefundedPercentage = (date?: any) => {
  return stpApi.postUnsigned(`/stats/lending-refunded-percentage/`, date, {});
};

export const getLendingPaidInterest = (date?: any) => {
  return stpApi.postUnsigned(`/stats/lending-paid-interest/`, date, {});
};

export const getUsersRegisteredByYear = () => {
  return stpApi.get(`/stats/excel-users-registered-by-year/`, {});
};

export const getTotalInvestedByYear = () => {
  return stpApi.get(`/stats/excel-total-invested-by-year/`, {});
};

export const getProjectCountByYear = () => {
  return stpApi.get(`/stats/excel-project-count-by-year/`, {});
};

export const getSeededAndNonSeededProjectsByYear = () => {
  return stpApi.get(`/stats/excel-seeded-project-count-by-year/`, {});
};

export const getProjectTransactionTotalByTypeAndYear = () => {
  return stpApi.get('/stats/excel-total-transaction-by-type-and-year/', {});
};

export const getAllProjectTransactionsWithProjectTypeByYear = () => {
  return stpApi.get('/stats/excel-total-transaction-by-year/', {});
};

export const getGenderInvestorsByYear = () => {
  return stpApi.get('/stats/excel-gender-investors-by-year/', {});
};

export const getGenderInvestmentsByYear = () => {
  return stpApi.get('/stats/excel-gender-investments-by-year/', {});
};

export const getAgeGroupInvestmentsByYear = () => {
  return stpApi.get('/stats/excel-age-group-investments-by-year/', {});
};

export const getAverageRatioByYear = () => {
  return stpApi.get('/stats/excel-get-average-ratio-by-year/', {});
};

export const getEquityExitProjectsByYear = () => {
  return stpApi.get('/stats/equity-exit-projects-by-year/', {});
};

export const getEquityPercievedAverageRentabilityByYear = () => {
  return stpApi.get('/stats/excel-equity-percieved-average-rentability-by-year/', {});
};

export const getEquityUnfinalizedInvestmentsByYear = () => {
  return stpApi.get('/stats/excel-equity-unfinalized-investments-by-year/', {});
};

export const getEquityCloseGoalSumByYear = () => {
  return stpApi.get('/stats/excel-equity-close-goal-sum-by-year/', {});
};

export const getEquityExitGoalSumByYear = () => {
  return stpApi.get('/stats/excel-equity-exit-goal-sum-by-year/', {});
};

export const getLendingProjectsFinishedLoanCountByYear = () => {
  return stpApi.get('/stats/excel-lending-finished-projects-by-year/', {});
};

export const getLendingProjectsUnpaidLoanCountByYear = () => {
  return stpApi.get('/stats/excel-lending-unpaid-projects-by-year/', {});
};

export const getLendingProjectsDelayedLoanPercentageByYear = () => {
  return stpApi.get('/stats/excel-lending-delayed-percentage-by-year/', {});
};

export const getLendingProjectsAveragePercievedProfitabilityByYear = () => {
  return stpApi.get('/stats/excel-lending-average-percieved-profitability-by-year/', {});
};

export const getLendingProjectsUnfinalizedLoanTotalByYear = () => {
  return stpApi.get('/stats/excel-lending-unfinalized-loan-total-by-year/', {});
};

export const getLendingProjectsFinalizedLoanTotalByYear = () => {
  return stpApi.get('/stats/excel-lending-finalized-loan-total-by-year/', {});
};

export const getLendingProjectsUnpaidLoanTotalByYear = () => {
  return stpApi.get('/stats/excel-lending-unpaid-loan-total-by-year/', {});
};

export const getLendingProjectsRepaidCapitalByYear = () => {
  return stpApi.get('/stats/excel-lending-repaid-capital-by-year/', {});
};

export const getLendingProjectsRefundedPercentageByYear = () => {
  return stpApi.get('/stats/excel-lending-refunded-capital-percentage-by-year/', {});
};

export const getLendingPaidInterestByYear = () => {
  return stpApi.get('/stats/excel-lending-paid-interest-by-year/', {});
};

export const getLendingRemainingCapitalByYear = () => {
  return stpApi.get('/stats/excel-lending-remaining-capital-by-year/', {});
};


//DASHBOARD
export const getEquityDashboardByUserId = (id: any) => {
  return stpApi.get(`/dashboard/equity/${id}`, {});
};

export const getLendingDashboardByUserId = (id: any) => {
  return stpApi.get(`/dashboard/lending/${id}`, {});
};

export const getLendingDashboardByUserAndProjectId = (userId: any, projectId: any) => {
  return stpApi.get(`/dashboard/lending/${userId}/${projectId}`, {});
};

export const getEquityDashboardByUserAndProjectId = (userId: any, projectId: any) => {
  return stpApi.get(`/dashboard/equity/${userId}/${projectId}`, {});
};

export const getAllInvestorsRefundsByUserId = (id: number) => {
  return stpApi.get(`/dashboard/refunds/${id}`, {})
}

export const getAllInvestorsRefundsByUserAndProjectId = (userId: any, projectId: any) => {
  return stpApi.get(`/dashboard/refunds/${userId}/${projectId}`, {})
}

export const getDashboardProjectData = (id: any) => {
  return stpApi.get(`/dashboard/${id}`, {})
}

export const createFinancialReport = (report: any) => {
  return stpApi.post(`/dashboard/reports`, report, {})
}

export const getFinancialReportsByProject = (id: any) => {
  return stpApi.get(`/dashboard/reports/${id}`, {})
}

export const updateFinancialReport = (id: any, report: any) => {
  return stpApi.put(`/dashboard/reports/${id}`, report, {})
}

export const getFinancialReportsForPDF = (id: any) => {
  return stpApi.get(`/dashboard/reports-pdf/${id}`, {})
}

// Dealflows

export const getAllDealflows = () => {
  return stpApi.get(`/dealflows`, {});
};

export const getDealflowById = (id: number | string) => {
  return stpApi.get(`/dealflows/${id}`, {});
};

export const createDealFlow = (dealflow: any) => {
  return stpApi.post(`/dealflows`, dealflow, {});
};

export const updateDealflow = (id: number | string, dealflow: any) => {
  return stpApi.put(`/dealflows/${id}`, dealflow, {});
};

export const uploadDealflowPicture = (
  id: string | number,
  pictureName: any,
  picture: any
) => {
  return stpApi.put(`/dealflows/${id}/${pictureName}`, picture, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const createDealflowDoc = (
  dealflowId: string | number,
  docName: any,
  doc: any
) => {
  return stpApi.post(`/dealflows/docs/${dealflowId}/${docName}`, doc, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteDealflowDoc = (id: number | string) => {
  return stpApi.delete(`/dealflows/docs/${id}`, {});
};

// Events

export const getAllEvents = () => {
  return stpApi.get(`/events`, {});
};

export const getEventById = (id: number | string) => {
  return stpApi.get(`/events/${id}`, {});
};

export const createEvent = (event: any) => {
  return stpApi.post(`/events`, event, {});
};

export const updateEvent = (id: number | string, event: any) => {
  return stpApi.put(`/events/${id}`, event, {});
};

export const uploadEventPicture = (
  id: string | number,
  pictureName: any,
  picture: any
) => {
  return stpApi.put(`/events/${id}/${pictureName}`, picture, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// New blog post

export const createBlogPost = (
  formData: any
) => {
  return stpApi.post(`/posts`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getAllPosts = (skip: number, limit: number, search: string, categories: string[]) => {
  const params: any = {
    skip,
    limit,
    search,
    categories: categories ? categories.join(',') : '',
  };

  return stpApi.getWithQueryParams(`/posts`, params);
};

export const getAllPublishedPosts = (skip: number, limit: number, search: string, categories: string[]) => {
  const params: any = {
    skip,
    limit,
    search,
    categories: categories ? categories.join(',') : '',
  };

  return stpApi.getWithQueryParams(`/posts/published`, params);
};

export const getPostById = (id: number | string) => {
  return stpApi.get(`/posts/${id}`, {});
};

export const getPostBySlug = (slug: string) => {
  return stpApi.get(`/posts/slug/${slug}`, {});
};

export const createPost = (post: any) => {
  return stpApi.post(`/posts`, post, {});
}

export const uploadPostPicture = (id: number | string, post: any) => {
  return stpApi.put(`/posts/picture-post/${id}`, post, {});
}

export const updatePost = (id: number | string, post: any) => {
  return stpApi.put(`/posts/${id}`, post, {});
}

// Jobs

export const getAllJobs = () => {
  return stpApi.get(`/jobs`, {});
};

export const getJobById = (id: number | string) => {
  return stpApi.get(`/jobs/${id}`, {});
};

export const createJob = (job: any) => {
  return stpApi.post(`/jobs`, job, {});
};

export const updateJob = (id: number | string, job: any) => {
  return stpApi.put(`/jobs/${id}`, job, {});
};

export const updateJobPosition = (id: number | string, position: any) => {
  return stpApi.put(`/jobs/position/${id}/${position}`, {}, {});
};


export const deleteJobById = (id: number | string) => {
  return stpApi.delete(`/jobs/${id}`, {});
};

// Tags

export const getAllTags = () => {
  return stpApi.get(`/tags`, {});
};

export const createTag = (tag: any) => {
  return stpApi.post(`/tags`, tag, {});
};

export const deleteTag = (id: number | string) => {
  return stpApi.delete(`/tags/${id}`, {});
};

// Post-Tags

export const getPostTagsByPostId = (postId: number | string) => {
  return stpApi.get(`/post-tags/${postId}`, {});
};

export const createPostTag = (postTag: any) => {
  return stpApi.post(`/post-tags`, postTag, {});
};

export const deletePostTag = (postId: number | string, tagId: number | string) => {
  return stpApi.delete(`/post-tags/${postId}/${tagId}`, {});
};

// Pcategories

export const getAllPcategories = () => {
  return stpApi.get(`/pcategories`, {});
};

export const createPcategory = (pcategory: any) => {
  return stpApi.post(`/pcategories`, pcategory, {});
};

export const deletePcategory = (id: number | string) => {
  return stpApi.delete(`/pcategories/${id}`, {});
};

// Post-Categories

export const getPostCategoriesByPostId = (postId: number | string) => {
  return stpApi.get(`/post-pcategories/${postId}`, {});
};

export const createPostCategory = (postPcategory: any) => {
  return stpApi.post(`/post-pcategories`, postPcategory, {});
};

export const deletePostCategory = (postId: number | string, pcategoryId: number | string) => {
  return stpApi.delete(`/post-pcategories/${postId}/${pcategoryId}`, {});
};

// Press

export const getAllPress = () => {
  return stpApi.get(`/press`, {});
};

export const getPressById = (id: number | string) => {
  return stpApi.get(`/press/${id}`, {});
};

export const createPress = (job: any) => {
  return stpApi.post(`/press`, job, {});
};

export const updatePress = (id: number | string, job: any) => {
  return stpApi.put(`/press/${id}`, job, {});
};

export const updatePressPosition = (id: number | string, position: any) => {
  return stpApi.put(`/press/position/${id}/${position}`, {}, {});
};

export const deletePress = (id: number | string) => {
  return stpApi.delete(`/press/${id}`, {});
};

// Transaction invoices

export const updateInvoiceNumberTransaction = (transactionId: number | string, body: any) => {
  return stpApi.put(`/transactions/invoice-number/${transactionId}`, body, {});
};

export const getInvoices = (projectId: number | string) => {
  return stpApi.get(`/invoices/${projectId}`, {});
};


// Project representative emails

export const getRepresentativeEmailByProjectId = (projectId: number | string) => {
  return stpApi.get(`/projects/representative-email/${projectId}`, {});
};

export const createRepresentativeEmailByProjectId = (projectId: number | string, email: string) => {
  return stpApi.post(`/projects/representative-email/${projectId}`, { email, projectId }, {});
};

export const deleteRepresentativeEmailByProjectId = (projectId: number | string, emailId: number) => {
  return stpApi.delete(`/projects/representative-email/${projectId}/${emailId}`, {});
};

